import React from 'react';

const ResendMessageIcon = () => (
    <span className='icon__compound trade-message'>
         <i className="fas fa-comment" aria-hidden="true" />
         <i className="fas fa-undo-alt hollow-text icon__compound--top-layer"/>
    </span>
);

export default ResendMessageIcon;